import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USERS_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_POST_EMPLOYER_BY_ID_SURVEY_RESULT,
  KEY_POST_EMPLOYER_BY_ID_SURVEY_RESULT,
} from '../constats';
import { MOCK_RESPONSE_POST_EMPLOYER_BY_ID_SURVEY_RESULT } from '../mocks';

type RequestPostEmployerByIdSurveyResult = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USERS_PATH_KEY
>['request']['body'];

export type ResponsePostEmployerByIdSurveyResult = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USERS_PATH_KEY
>['response']['body'];

export type CallParamsPostEmployerByIdSurveyResult = Omit<
  RequestPostEmployerByIdSurveyResult,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostEmployerByIdSurveyResult = ResponsePostEmployerByIdSurveyResult;

type CallErrorPostEmployerByIdSurveyResult = {
  message: string;
  code: number;
};

type CallSelectorsPostEmployerByIdSurveyResult = {
  hasCompletedSurvey: boolean;
};

export const postEmployerByIdSurveyResultCall = createGeneralCall<
  CallParamsPostEmployerByIdSurveyResult,
  CallResponsePostEmployerByIdSurveyResult,
  CallErrorPostEmployerByIdSurveyResult,
  CallSelectorsPostEmployerByIdSurveyResult
>({
  id: KEY_POST_EMPLOYER_BY_ID_SURVEY_RESULT,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_EMPLOYER_BY_ID_SURVEY_RESULT(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'post',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_EMPLOYER_BY_ID_SURVEY_RESULT : undefined,
  selectors: {
    hasCompletedSurvey: ({ selectors }) =>
      createSelector(selectors.response, res => {
        if (res.length === 0) {
          return false;
        }
        return res.length > 0 && res.some(item => item.completed === true);
      }),
  },
});
